


import { useClienteContext } from '../../../contexts/ClienteContext';

const sucursalNombre = {
    buch: 'Buchardo',
    val: 'Villa Valeria',
    lab: 'Laboulaye',
    ser: 'Serrano',
    mel: 'Melo',
    ita: 'Pueblo Italiano',
    sur: 'Integral Sur',
};

export default function HomeCliente() {
    const sucursal = localStorage.getItem('sucursal');
    const nombre = sucursalNombre[sucursal] || sucursal;

    return (
        <div className="flex flex-col h-full bg-[#050f08]">

            {/* CONTENIDO CENTRAL */}
            <div className="flex-1 flex flex-col justify-center items-center relative overflow-hidden px-6">

                {/* GLOW DE FONDO */}
                <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
                    <div className="w-[600px] h-[600px] rounded-full"
                        style={{ background: 'radial-gradient(circle, rgba(201,168,76,0.04) 0%, transparent 70%)' }} />
                </div>

                <div className="relative z-10 flex flex-col items-center gap-8">


                    {/* NOMBRE SUCURSAL */}
                    <div className="text-center">
                        <div className="text-[#c9a84c] text-[9px] font-black uppercase tracking-[0.6em] mb-3">
                            Sucursal activa
                        </div>
                        <h1 className="text-white text-3xl font-black tracking-tighter uppercase">
                            {nombre}
                        </h1>
                        <div className="flex items-center justify-center gap-3 mt-4">
                            <div className="h-px w-16 bg-white/10" />
                            <div className="w-1.5 h-1.5 rounded-full bg-[#c9a84c] animate-pulse" />
                            <div className="h-px w-16 bg-white/10" />
                        </div>
                        <p className="text-white/20 text-[10px] uppercase tracking-[0.4em] font-bold mt-4">
                            Integral Agropecuaria S.R.L
                        </p>
                    </div>

                  
                </div>
            </div>

            {/* FOOTER */}
            <div className="flex-shrink-0  bg-[#050f08] px-4 py-6 md:py-2.5 lg:py-2.5 flex items-center justify-between border-t border-white/5">
                <span className="text-gray-400 text-[10px] uppercase tracking-widest font-bold">Portal de clientes</span>
                <span className="text-white/20 text-[9px] uppercase tracking-[0.4em] font-bold">
                    © {new Date().getFullYear()} Integral Agropecuaria
                </span>
            </div>
        </div>
    );
}